module.exports = __webpack_public_path__ + "img/ltkholiday-3x.2a96cc3.jpg";